import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { ConfirmDialog } from "primereact/confirmdialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import React from "react";
import { FR_SUFFIX } from "../../entities/Constants";
import { FormSectionElements } from "src/entities/formTemplateDataType";
import Utils from "../../utilities/Utils";
import { DialogBase, Props } from "./DialogBase";


interface State {
    confirmVisible: boolean;
    deleteIndex: number;
}

export class TableMenuDesignComponent extends DialogBase<Props,State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            confirmVisible: false,
            deleteIndex: -1,
        };
    }

    confirmRemove = () => {
        const { deleteIndex } = this.state;
        let p = this.props.ele;
        p.TableMenuRows.splice(deleteIndex, 1);
        this.props.callback();
        this.setState({ confirmVisible: false });
    };

    render () {
        let htmlString = [];
        let p = this.props.ele;
        if (!p.TableMenuRows) {
            p.TableMenuRows = [];
        }

        if(p.TableMenuRows.length == 0) {
            p.TableMenuRows.push({value: "", valueFRA: "", stepIndex: 0});
        }
        
        htmlString.push(
            <div style={{display:"flex", marginBottom:'5px'}}>
                <div>
                    {/* @ts-ignore */}
                    <Checkbox id={'chk_isDashboard' + p.Id} key={'chk_isDashboard' + p.Id} 
                    checked={p.CMADashboard} 
                    onChange={(e) => {
                        p.CMADashboard = e.checked;
                        this.props.callback();
                    }} ></Checkbox>
                </div>
                <div style={{ paddingLeft: '3px' }}>
                    <label htmlFor={'chk_isDashboard' + p.Id} className="p-checkbox-label">CMA dashboard</label>
                </div>
            </div>
        );

        p.TableMenuRows.forEach((rowData, index) => {
            htmlString.push(
                <div style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-start",
                    paddingTop: "5px",
                    alignItems: "center"
                }}
                key={"row_" + index}>
                    <div style={{ marginRight: "5px" }}>{index + 1}</div>
                    <div>
                        <i className="fa fa-regular fa-circle-dot"></i>
                    </div>
                    <div style={{ width: "50%" }}>
                        <InputText
                            className="ontario-input"
                            placeholder={"Row " + (index + 1).toString()}
                            value={this.props.isEng? rowData.value : rowData.valueFRA}
                            onChange={(e) => {
                                if (this.props.isEng) { 
                                    if(Utils.willDefaultFR(rowData.Value,rowData.ValueFRA)){
                                        rowData.ValueFRA = Utils.isNullOrEmpty(e.target.value)? '':e.target.value + FR_SUFFIX;
                                    }
                                    rowData.value = e.target.value;
                                } else {
                                    rowData.valueFRA = e.target.value;
                                }
                                this.props.callback();
                            }}
                        ></InputText>
                    </div>
                    <div style={{ width: "20%", marginLeft: "10px" }}>
                        <label htmlFor={"stepindex_row" + String(index)}>Step Index:</label>
                        <InputNumber
                            inputId={"stepindex_row" + String(index)}
                            value={rowData.stepIndex}
                            onChange={(e) => {
                                rowData.stepIndex = e.value;
                                this.props.callback();
                            }}
                        ></InputNumber>
                    </div>
                    <div style={{ marginLeft: "10px" }}>
                        <i
                            title="Remove me"
                            className="pi pi-trash"
                            style={{ fontSize: "1rem", cursor: "pointer" }}
                            onClick={() => {
                                this.setState({ confirmVisible: true, deleteIndex: index });
                            }}
                        ></i>
                    </div>

                </div>
            );
        });
        
        htmlString.push(
            <div key={"addoption_" + p.Id}>
                {/* @ts-ignore */}
                <Button
                    className="p-button-rounded p-button-secondary"
                    style={{
                        cursor: "pointer",
                        margin: "5px",
                        fontSize: "90%",
                        border: "1px solid #64748B",
                        color: "#64748B",
                        background: "white"
                    }}
                    onClick={() => {
                        p.TableMenuRows.push({value: "", valueFRA: "", stepIndex: 0});
                        this.props.callback();
                    }}>
                    Add option
                </Button>
            </div>
        );

        htmlString.push(
            
            <ConfirmDialog
                visible={this.state.confirmVisible}
                onHide={() => this.setState({ confirmVisible: false })}
                message="Are you sure you want to remove this?"
                header="Confirmation"
                icon="pi pi-exclamation-triangle"
                accept={this.confirmRemove}
                reject={() => this.setState({ confirmVisible: false })}
                closable={false}
            />
        );
        return(htmlString);
    }

}